import {
  lookupTranslatedName as lookupTranslatedNameInCatalog,
  matchLanguage,
  resolveLanguage,
} from './resolveLanguage';

export const languageCatalog = {
  en: {
    key: 'en',
    name: 'common:languages.english',
    untranslatedName: 'English',
  },
  es: {
    key: 'es',
    name: 'common:languages.spanish',
    untranslatedName: 'Español',
  },
  de: {
    key: 'de',
    name: 'common:languages.german',
    untranslatedName: 'Deutsch',
  },
  cs: {
    key: 'cs',
    name: 'common:languages.czech',
    untranslatedName: 'Česky',
  },
  ja: {
    key: 'ja',
    name: 'common:languages.japanese',
    untranslatedName: '日本語',
  },
  sk: {
    key: 'sk',
    name: 'common:languages.slovak',
    untranslatedName: 'Slovák',
  },
  it: {
    key: 'it',
    name: 'common:languages.italian',
    untranslatedName: 'Italiano',
  },
  fr: {
    key: 'fr',
    name: 'common:languages.french',
    untranslatedName: 'Français',
  },
  pl: {
    key: 'pl',
    name: 'common:languages.polish',
    untranslatedName: 'Polski',
  },
  pt: {
    key: 'pt',
    name: 'common:languages.portuguese',
    untranslatedName: 'Português',
  },
  'pt-br': {
    key: 'pt-br',
    name: 'common:languages.portugueseBrazil',
    untranslatedName: 'Português (Brasil)',
  },
  'zh-hk': {
    key: 'zh-hk',
    name: 'common:languages.chinese',
    untranslatedName: '繁體中文（香港）',
  },
} as const;

export type LanguageCode = keyof typeof languageCatalog;

export const languageCodes = Object.keys(languageCatalog) as LanguageCode[];

export function resolveLanguageCode(
  rawTagOrTags: string | undefined | null | readonly string[],
): LanguageCode {
  return resolveLanguage(rawTagOrTags ?? '', languageCodes) as LanguageCode;
}

export function lookupTranslatedName(
  translatedNames: Record<string, string | undefined | null> | undefined | null,
  rawTag: string | undefined | null,
  defaultName: string,
): string {
  return lookupTranslatedNameInCatalog(translatedNames, rawTag, defaultName, languageCodes);
}

export function matchesLanguageCode(
  rawTag: string | undefined | null,
  languageCode: string,
): boolean {
  const stored = matchLanguage(rawTag, languageCodes);
  const expected = matchLanguage(languageCode, languageCodes);
  return stored !== undefined && stored === expected;
}
